export default "__VITE_ASSET__a5b0b767__"